// Module
var code = `<div class="process-balance">
    <div class="row">
        <div class="col-md-4">
            <div class="card">
                <div class="card-header">
                    <h5>Upload & Configure</h5>
                </div>
                <div class="card-body">
                    <!-- Upload Area -->
                    <div class="upload-area" id="uploadArea">
                        <input type="file" id="fileInput" accept=".txt,.ds,.ds.txt" style="display:none" />
                        <div class="upload-prompt">
                            <i class="upload-icon">📁</i>
                            <p>Drag & drop Avid DS file here</p>
                            <small class="text-muted">Supported: .ds, .ds.txt</small>
                        </div>
                    </div>

                    <!-- Options Panel -->
                    <div class="options-panel" id="optionsPanel" style="display:none">
                        <div class="mb-3">
                            <label class="form-label">Current File</label>
                            <div class="alert alert-secondary" id="currentFile"></div>
                        </div>

                        <div class="mb-3">
                            <label for="maxLineLength" class="form-label">Max Line Length</label>
                            <input type="number" id="maxLineLength" class="form-control" value="38" min="1" max="100" />
                            <small class="form-text text-muted">Maximum characters per line</small>
                        </div>

                        <div class="form-check mb-3">
                            <input type="checkbox" id="allowLongerSecondLine" class="form-check-input" checked />
                            <label for="allowLongerSecondLine" class="form-check-label">
                                Allow Longer Second Line
                            </label>
                            <small class="form-text text-muted d-block">Permits second line to be slightly longer for better balance</small>
                        </div>

                        <!-- Action Buttons -->
                        <div class="actions">
                            <button type="button" id="validateBtn" class="btn btn-outline-primary w-100 mb-2">
                                <span class="btn-text">Validate</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="balanceBtn" class="btn btn-success w-100 mb-2">
                                <span class="btn-text">Balance Lines</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="downloadBtn" class="btn btn-primary w-100" style="display:none">
                                Download Result
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-8">
            <!-- Validation Messages -->
            <div id="messagesContainer" style="display:none"></div>

            <!-- Editor -->
            <div class="card" id="editorCard" style="display:none">
                <div class="card-header">
                    <h5>Document Editor</h5>
                </div>
                <div class="card-body" style="height: 600px">
                    <doc-editor id="docEditor"></doc-editor>
                </div>
            </div>

            <!-- Placeholder -->
            <div class="card" id="placeholderCard">
                <div class="card-body text-center text-muted">
                    <p class="lead">Upload an Avid DS file to begin balancing</p>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;